import api from '@/api/Api'
import GeoJsonVector from '@models/vector/vector-geojson'
import VectorMbtile from '@models/vector/vector-mbtile'
import store from '@state/store'
import transformUtils from '@utils/transformUtils'

export const state = {
  uploadDialog: true,
  vectors: [],
  vectorShared: [],
  allVectors: [],
  taskUpload: [],
  uploading: false,
  listCancel: [],
  resetDataVector: true,
  folderId: null,
  folders: [],
  sharedFolders: [],
  sharedPage: 1,
  sharedPerPage: 36,
  sharedFolderId: null,
  myVectorRoute: [
    {
      disabled: false,
      id: null,
      name: 'Root'
    }
  ],
  sharedVectorRoute: [
    {
      disabled: false,
      id: null,
      name: 'Root'
    }
  ],
  showedVectors: []
}

export const getters = {
  vectors(state) {
    return state.vectors
  },
  allVectors(state) {
    return state.allVectors
  },
  uploadDialog(state) {
    return state.uploadDialog
  },
  vectorShared(state) {
    return state.vectorShared
  },
  taskUpload(state) {
    return state.taskUpload
  },
  resetDataVector(state) {
    return state.resetDataVector
  },
  folderId: state => state.folderId,
  folders: state => state.folders,
  sharedFolderId: state => state.sharedFolderId,
  sharedFolders: state => state.sharedFolders,
  myVectorRoute: state =>
    state.myVectorRoute.map((route, index, array) => ({
      ...route,
      disabled: index === array.length - 1
    })),
  sharedVectorRoute: state =>
    state.sharedVectorRoute.map((route, index, array) => ({
      ...route,
      disabled: index === array.length - 1
    }))
}

export const mutations = {
  CLOSE_POPUP(state) {
    state.uploadDialog = !state.uploadDialog
  },
  SET_SHOWED_VECTORS(state, newValue) {
    state.showedVectors = newValue
  },
  RESET_DATA_VECTOR(state) {
    state.resetDataVector = !state.resetDataVector
  },
  SET_VECTORS(state, appendVectors) {
    for (let vector of appendVectors) {
      if (!(state.vectors.filter(v => v.id === vector.id).length > 0)) {
        state.vectors.push(vector)
      }
    }
  },
  SET_ALL_VECTORS(state, newValue) {
    state.allVectors = newValue
  },
  RESET_VECTORS(state) {
    state.vectors = []
  },
  SET_VECTORS_SHARED(state, newValue) {
    let oldVectors = state.vectorShared
    state.vectorShared = []
    state.vectorShared = oldVectors.concat(newValue)
  },
  RESET_VECTORS_SHARED(state) {
    state.vectorShared = []
  },
  SET_SHARED_FOLDERS(state, payload) {
    state.sharedFolders = payload
  },
  SET_STATUS_UPLOAD(state, newValue) {
    if (state.taskUpload.length > 0) {
      let task = state.taskUpload.find(val => val.id === newValue.id)
      if (task) {
        if (!task.cancel) {
          task.cancel = state.listCancel.find(val => val.id === task.id).cancel
        }
        task.percent = newValue.percent
      } else {
        if (newValue.percent !== 100) state.taskUpload.push(newValue)
      }
    } else {
      state.taskUpload.push(newValue)
    }
  },
  SET_CANCEL_UPLOAD(state, newValue) {
    state.listCancel.push(newValue)
  },
  DELETE_STATUS_UPLOAD(state, id) {
    if (id) {
      state.taskUpload = state.taskUpload.filter(val => val.id !== id)
    } else {
      state.taskUpload = state.taskUpload.filter(
        val => val.percent !== 100 || val.error
      )
    }
    if (state.taskUpload.length <= 0) {
      state.uploading = false
    }
  },
  SET_STATUS(state, newValue) {
    state.uploading = newValue
  },
  SET_TASK(state, newValue) {
    state.taskUpload = state.taskUpload.concat(newValue)
  },
  SET_LIST_ERROR(state, id) {
    let ind = state.taskUpload.findIndex(val => val.id === id)
    if (ind >= 0) {
      state.taskUpload[ind].error = true
    }
  },

  SET_MY_VECTOR_ROUTE(state, payload) {
    state.myVectorRoute = payload
  },
  SET_SHARED_VECTOR_ROUTE(state, payload) {
    state.sharedVectorRoute = payload
  },
  SET_FOLDERS: (state, payload) => {
    state.folders = payload
  },
  SET_FOLDER_ID: (state, payload) => {
    state.folderId = payload
  },
  SET_VECTOR_QTY: (state, payload) => {
    state.vectorQty = payload
  },
  SET_VECTOR_TOTAL: (state, payload) => {
    state.vectorTotal = payload
  },
  SET_SHARED_FOLDER_ID: (state, payload) => {
    state.sharedFolderId = payload
  },
  UPDATE_VISIBLE(state, data) {
    state.vectors.map(val => {
      if (val.id === data.id) {
        val.visible = data.visible
      }
    })
  }
}
export const actions = {
  copyToWorkspace({ commit, state }, form) {
    return api.copyVectorTo(form).then(response => {
      return response
    })
  },
  getFolder({ commit, state }, form) {
    return api.getDataFolderVector(form).then(response => {
      return response.data.data
    })
  },
  getVector({ commit, state }, data) {
    if (data.reset) commit('RESET_VECTORS')
    return api
      .getVector({ ...data, folderId: state.folderId })
      .then(response => {
        const vectors = response.data.data.vectors.data.map(val => {
          if (val.is_geojson) {
            return new GeoJsonVector(val)
          } else {
            return new VectorMbtile(val)
          }
        })
        commit('SET_VECTORS', vectors)
        commit('SET_FOLDERS', response.data.data.folders)
        return response.data.data
      })
  },
  getVectorShared({ commit, state }, data) {
    if (data.reset) commit('RESET_VECTORS_SHARED')
    return api
      .getVectorShared({ ...data, folderId: state.sharedFolderId })
      .then(response => {
        const vectors = response.data.data.vectors.data.map(val => {
          if (val.is_geojson) {
            return new GeoJsonVector(val)
          } else {
            return new VectorMbtile(val)
          }
        })
        commit('SET_VECTORS_SHARED', vectors)
        commit('SET_SHARED_FOLDERS', response.data.data.folders)
        return response.data.data
      })
  },
  makeCopyVector({ commit, dispatch, state }, data) {
    return api.makeCopyVector(data).then(response => {
      store.dispatch('task/refresh', {
        workspaceId: data.workspaceId
      })
      return response.data
    })
  },
  async fetchVector({ commit, dispatch, state }, workspaceId) {
    const { data } = await api.getListVector(workspaceId)
    // let vectorMbtile = [...data.data.vectors];
    const vectors = [
      ...data.data.folders.map(val => ({
        ...val,
        itemType: 'folder',
        parentId: val.parent_id
      })),
      ...data.data.vectors.map(val => {
        return new VectorMbtile({
          ...val,
          itemType: 'vector'
        })
      })
    ]
    // vectorMbtile.forEach(async vector => {
    //   const resFilter = await api.filterMBTiles({
    //     wksId: workspaceId,
    //     id: vector.id
    //   });
    //   vector.featureCount = resFilter.data.data.feature_count;
    //   vectors.push(
    //     new VectorMbtile({
    //       ...vector,
    //       itemType: "vector"
    //     })
    //   );
    // });
    commit('SET_ALL_VECTORS', vectors)
    commit('RESET_DATA_VECTOR')
    return vectors
  },
  deleteVector({ commit, dispatch, state }, data) {
    return api.deleteVector(data).then(response => {
      return response.data
    })
  },
  removeShared({ commit, dispatch, state }, data) {
    return api.removeSharedVector(data).then(response => {
      return response.data
    })
  },
  updateVector({ commit, state }, data) {
    return api.updateVector(data).then(response => {
      return response.data
    })
  },
  uploadVectorFile({ commit, dispatch, state }, data) {
    if (data) {
      commit('SET_STATUS', true)
      api
        .uploadVectorFile(data.data)
        .then(res => {
          store.dispatch('task/refresh', {
            workspaceId: data.data.form.id
          })
          store.dispatch('message/setNotification', {
            type: 'success',
            active: true,
            message: res.data.message
          })
          commit('DELETE_STATUS_UPLOAD', data.id)
        })
        .catch(er => {
          store.dispatch('message/setNotification', {
            type: 'error',
            active: true,
            message: er.message ? er.message : 'task canceled'
          })
          commit('DELETE_STATUS_UPLOAD', data.id)
          commit('SET_LIST_ERROR', data.id)
        })
        .finally(() => {
          // commit('CLOSE_POPUP')
          dispatch('checkStatusUpload')
        })
    }
  },
  checkStatusUpload({ commit, dispatch, state }) {
    const taskCreated = state.taskUpload.find(val => !val.error)
    if (taskCreated) {
      dispatch('uploadVectorFile', taskCreated)
    } else {
      commit('SET_STATUS', false)
    }
  },
  startUpload({ commit, dispatch, state }, data) {
    state.taskUpload.push(data)
    if (!state.uploading) {
      dispatch('checkStatusUpload')
    }
  },
  createFolder: async (
    { commit, dispatch },
    { workspaceId, name, folderId }
  ) => {
    const res = await api.createVectorFolder({ folderId, workspaceId, name })
    commit('RESET_DATA_VECTOR')
    return res
  },
  selectFolder: async ({ commit, dispatch }, { folder, workspaceId }) => {
    commit('SET_FOLDER_ID', folder.id)
    dispatch('changeMyVectorRoute', { folder })
  },
  selectSharedFolder: async ({ commit, dispatch }, { folder, workspaceId }) => {
    commit('SET_SHARED_FOLDER_ID', folder.id)
    dispatch('changeSharedVectorRoute', { folder })
  },
  changeMyVectorRoute: ({ commit, state }, { folder }) => {
    const index = state.myVectorRoute.findIndex(
      route => route.id === folder.id
    )
    if (folder.id === null) {
      commit('SET_MY_VECTOR_ROUTE', [
        {
          id: null,
          name: 'root'
        }
      ])
    } else if (index !== -1) {
      commit('SET_MY_VECTOR_ROUTE', state.myVectorRoute.slice(0, index + 1))
    } else {
      commit('SET_MY_VECTOR_ROUTE', [...state.myVectorRoute, folder])
    }
  },
  changeSharedVectorRoute: ({ commit, state }, { folder }) => {
    const index = state.sharedVectorRoute.findIndex(
      route => route.id === folder.id
    )
    if (folder.id === null) {
      commit('SET_SHARED_VECTOR_ROUTE', [
        {
          id: null,
          name: 'root'
        }
      ])
    } else if (index !== -1) {
      commit(
        'SET_SHARED_VECTOR_ROUTE',
        state.sharedVectorRoute.slice(0, index + 1)
      )
    } else {
      commit('SET_SHARED_VECTOR_ROUTE', [...state.sharedVectorRoute, folder])
    }
  },
  renameFolder: async (
    { commit, dispatch, state },
    { workspaceId, folderId, name }
  ) => {
    const res = await api.renameVectorFolder({ workspaceId, folderId, name })
    commit('RESET_DATA_VECTOR')
    return res
  },
  moveFolder: async (
    { commit, dispatch, state },
    { workspaceId, folderId, parentId }
  ) => {
    const res = await api.moveVectorFolder({ workspaceId, folderId, parentId })
    commit('RESET_DATA_VECTOR')
    return res
  },
  deleteFolder: async (
    { commit, dispatch, state },
    { workspaceId, folderId }
  ) => {
    const res = await api.deleteVectorFolder({ workspaceId, folderId })
    commit('RESET_DATA_VECTOR')
    return res
  },
  shareFolder: async (
    { commit, dispatch, state },
    { workspaceId, folderId, emails }
  ) => {
    await api.shareVectorFolder({ workspaceId, folderId, emails })
    commit('RESET_DATA_VECTOR')
  },
  makeCopyFolder: async (
    { commit, dispatch, state },
    { workspaceId, folderId }
  ) => {
    const res = await api.makeCopyVectorFolder({ workspaceId, folderId })
    commit('RESET_DATA_VECTOR')
    store.dispatch('task/refresh', { workspaceId })
    return res
  },
  removeSharedFolder: async ({ commit, dispatch, state }, { folderId }) => {
    await api.removeSharedVectorFolder({ folderId })
    commit('RESET_DATA_VECTOR')
  },
  removeSharedFolderUser: async (
    { commit, dispatch, state },
    { workspaceId, folderId, email }
  ) => {
    await api.removeSharedVectorFolderUser({ workspaceId, folderId, email })
    commit('RESET_DATA_VECTOR')
  },
  resetRoute: ({ commit }) => {
    commit('SET_MY_VECTOR_ROUTE', [
      {
        disabled: false,
        id: null,
        name: 'Root'
      }
    ])
    commit('SET_SHARED_VECTOR_ROUTE', [
      {
        disabled: false,
        id: null,
        name: 'Root'
      }
    ])
  },
  afterSelectWorkspace({ commit, dispatch, rootState }) {
    let workspaceId = rootState.auth.currentWorkspace
    commit('SET_MY_VECTOR_ROUTE', [
      {
        name: 'Root',
        disabled: true,
        id: ''
      }
    ])
    dispatch('fetchVector', workspaceId)
  },
  getTypeOfVector: async ({ }, { vector, workspaceId }) => {
    if (vector.geometryType) {
      vector.typeOfVector = vector.geometryType
    } else {
      const { data } = await api.getTypeOfVector({
        wksId: workspaceId,
        id: vector.id
      })
      vector.typeOfVector = data.data ? data.data : 'POLYGON'
    }
    return vector
  },
  getDisplayTypeVector: async ({ }, { vector }) => {
    if (vector.originDisplayType) {
      vector.displayType =
        vector.originDisplayType !== 'point'
          ? vector.originDisplayType
          : 'circle'
    } else if (
      vector.type === 'mbtiles' ||
      vector.typeOfVector.toUpperCase() === 'LINESTRING'
    ) {
      vector.displayType = 'line'
    } else if (vector.typeOfVector.toUpperCase() === 'POINT') {
      vector.displayType = 'circle'
    }
    return vector
  },
  getDetailVectorPBF: async ({ }, { vector, workspaceId }) => {
    if (vector.type !== 'mbtiles') {
      const { data } = await api.getListFeature({
        id: vector.id,
        wksId: workspaceId,
        data: {
          per_page: 10,
          page: 1
        }
      })
      vector.properties = data.data
      const resProperties = await api.getListProperty({
        vectorId: vector.id,
        wksId: workspaceId
      })
      resProperties.data.data.forEach(property => {
        if (property.column_default) {
          property.column_default = property.column_default
            .split('::')[0]
            .replace(/'/g, '')
        }
        let vectorPropertiesValue = transformUtils.transformTableData(
          property.column_default,
          property.data_type
        )
        vector.listProperties.push({
          name: property.column_name,
          type: property.data_type,
          value: vectorPropertiesValue,
          default: vectorPropertiesValue,
          maximumLength: property.character_maximum_length
        })
      })
    }
    const { data } = await api.getVectorTileInfo(vector.tileUrl)
    vector.bbox = data.bounds ? data.bounds : vector.bbox
    return vector
  },
  createTaskUpload({ commit, state, dispatch }, data) {
    return api
      .createTaskUploadVector(data.taskData)
      .then(val => {
        store.dispatch('message/setNotification', {
          type: 'success',
          active: true,
          message: val.data.message ? val.data.message : 'Successful'
        })
        store.dispatch('task/refresh', {
          workspaceId: data.taskData.wksId,
          folderId: state.currentFolder
        })
      })
      .catch(er => {
        store.dispatch('message/setNotification', {
          type: 'error',
          active: true,
          message: er.message ? er.message : 'Server error'
        })
      })
  },
}



// WEBPACK FOOTER //
// ./src/state/modules/vector.js